import { useState, useCallback } from "react";
import { defineMessages } from "react-intl";

import { useFormatMessage } from "../Intl/Context";
import Modal from "../Modals/Modal";
import PhoneNumberChangeEnrollmentStep from "./PhoneNumberChangeEnrollmentStep";
import PhoneNumberChangeChallengeStep from "./PhoneNumberChangeChallengeStep";

const ENROLLMENT_STEP = "ENROLLMENT";
const CHALLENGE_STEP = "CHALLENGE";

const PhoneNumberChangeModal = ({ onClose }) => {
  const t = useFormatMessage();
  const title = t(intlMessages.title);

  const [step, setStep] = useState(ENROLLMENT_STEP);

  const handleEnrolled = useCallback(() => setStep(CHALLENGE_STEP), []);
  const handleConfirmed = useCallback(() => onClose(), [onClose]);

  return (
    <Modal isOpen={true} title={title} onRequestClose={onClose}>
      {step === ENROLLMENT_STEP && (
        <PhoneNumberChangeEnrollmentStep onEnrolled={handleEnrolled} />
      )}

      {step === CHALLENGE_STEP && (
        <PhoneNumberChangeChallengeStep onConfirmed={handleConfirmed} />
      )}
    </Modal>
  );
};

export default PhoneNumberChangeModal;

const intlMessages = defineMessages({
  title: {
    id: "profile.phoneNumber.modal.title",
    defaultMessage: "Modifier mon numéro de mobile"
  }
});
